import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import AudienceDashboard from '../AudienceDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import AudiencePageImpl from './AudiencePageImpl';

export default function AudiencePage() {
    const dispatch = useDispatch();
    const { audienceList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < AudiencePageImpl />
    )

}